var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottom2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 39,
    viewBox: "0 0 56 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8623_8698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15 0H26V42H-15V0Z",
    fill: "#F1C9D1",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 39.8667L41.6266 24.0001L56.4461 57.2756L20.8195 73.1422L6 39.8667Z",
    fill: "#F1C9D1",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8623_8698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom2);
export default __webpack_public_path__ + "static/media/bottom2.8c16617cf7a03bbbf1d6c9377fe0bf3b.svg";
export { ForwardRef as ReactComponent };